let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("czNnV")).then(() => parcelRequire('fRcce'));